import { call, put, select, takeEvery } from 'redux-saga/effects';

import actions from './actions';
import selectors from './selectors';
import types from './types';
import api from './api';

function* watchStore() {
    yield takeEvery(types.LOAD_STORE_DETAILS, function*(action) {
        const storeUid = action.payload;
        const storeUidFromStore = yield select(state => selectors.getUid(state));
        if (storeUidFromStore === storeUid) {
            return;
        }
        try {
            const response = yield call(api.getStoreDetails, storeUid);
            yield put(actions.setStoreDetails(response));
        } catch (event) {
            /* nothing */
        }
    });
}

export default [watchStore()];
